import { useEffect, useState } from 'react'
import {
  loadBillingCatalog,
  policyBillingCatalog,
  type BillingCatalog,
} from '../lib/billingCatalog'

export function useBillingCatalog() {
  const [catalog, setCatalog] = useState<BillingCatalog>(policyBillingCatalog)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    void loadBillingCatalog()
      .then((next) => {
        if (active) setCatalog(next)
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [])

  return { catalog, loading }
}
